import { gql, TypedDocumentNode } from "@apollo/client";
import {
  IndexFileMutationVariables,
  IndexFileMutation,
} from "generated/graphql";

export const INDEX_FILE_MUTATION: TypedDocumentNode<
  IndexFileMutation,
  IndexFileMutationVariables
> = gql`
  mutation IndexFile($path: String!) {
    indexFile(path: $path)
  }
`;
